import { useState } from 'react';
import { CustomDialog, Button } from '../../components';
import { downLoadLink } from '../../utils/functions/common';
import { useAppDispatch } from '../../storeHook';
import { showAlert } from '../../services/alert';
import * as yup from 'yup';
import { useFormWithSchema } from '../../utils/functions/yupFormTypescript';
import { useGetAllPlantsQuery } from '../../services/common';
import { useLazyDemandPlanningExportQuery } from '../../services/demandPlanning';
import MultiSelect from '../../components/formControllers/multiSelect';

const formSchema = yup.object({
  depots: yup.array(yup.string().required()).required(),
});
type TFormData = yup.InferType<typeof formSchema>;

export const Export: React.FC = () => {
  const { data: plantList } = useGetAllPlantsQuery();
  const formattedPlantList = plantList?.map((ele) => ({
    value: ele.plantCode,
    label: `${ele.plantName} [${ele.plantCode}]`,
  }));

  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useFormWithSchema(formSchema, {
    mode: 'onTouched',
  });

  const dispatch = useAppDispatch();
  const [exportAction] = useLazyDemandPlanningExportQuery();
  const [open, setOpen] = useState(false);

  const onExportClick = (data: TFormData) => {
    exportAction({
      depots: data.depots,
    })
      .unwrap()
      .then((res) => {
        downLoadLink(res.url);
        dispatch(
          showAlert({
            content: res.url
              ? 'Exported Successfully'
              : 'No data found with applied conditions',
            severity: res.url ? 'success' : 'error',
          })
        );
      })
      .catch((err) => {
        console.log('error', err);
        // this.utility.handleError(err);
      });
  };

  return (
    <>
      <Button
        onClick={() => setOpen(!open)}
        className="ml-2"
        variant="button--secondary">
        Inventory Export
      </Button>
      <CustomDialog
        dialogTitle={'Inventory Replenishment Export'}
        open={open}
        setOpen={setOpen}
        onSubmit={handleSubmit((data) =>
          onExportClick(data)
        )}
        actionText={{ submit: 'Export', cancel: 'Cancel' }}
        maxWidth="sm">
        <form
          onSubmit={handleSubmit((data) =>
            onExportClick(data)
          )}
          className="mb-10 pb-20">
          <MultiSelect
            label="Plants"
            name="depots"
            control={control}
            options={formattedPlantList}
            error={errors.depots?.message}
            required
          />
        </form>
      </CustomDialog>
    </>
  );
};
